/**
 * Update price
 *
 * @return {void}
 */
const updatePrice = () => {
  const currentProduct = window.CURRENT_PRODUCT;
  const currentPrice = window.CURRENT_PRICE;

  const compareAtPriceField = window.COMPARE_AT_PRICE_FIELD;
  const priceField = window.PRICE_FIELD;

  let percentage = false;
  let priceUpdated = false;

  for (let i = 0; i < currentProduct.tags.length; i++) {
    if (currentProduct.tags[i].includes("Korting_")) {
      const tag = currentProduct.tags[i].slice(8);
      percentage = parseInt(tag);
      break;
    }
  }

  if (percentage) {
    let priceInt = currentPrice.slice(1).replace(",", ".");
    priceInt = parseFloat(priceInt);

    let priceDiff = (priceInt / 100) * percentage;
    priceUpdated = priceInt - priceDiff;
    priceUpdated = roundDecimals(priceUpdated, 2).toFixed(2);

    let priceFormatted = priceUpdated.toString().replace(".", ",");

    // $("[data-price-compare-at] .money").html(currentPrice);
    // $("[data-price] .money").html(`&euro;${priceFormatted}`);
    compareAtPriceField.html(currentPrice);
    priceField.html(`&euro;${priceFormatted}`);
  }
};

const addDecimal = (number) => {
  return Number((number / 100).toFixed(2));
};

const roundDecimals = (number, decimals) => {
  return Number(Math.round(number + "e" + decimals) + "e-" + decimals);
};

/**
 * VaeiantPriceController
 *
 * @return {void}
 */
const VariantPriceController = () => {
  window.WhatSub.subscribe("PRICE_UPDATE", updatePrice);
};

export default VariantPriceController;



// WEBPACK FOOTER //
// ./src/js/modules/product/controllers/VariantPriceController.js